import {
    UPDATE_LOCATION,
    RECEIVE_LAZY_RESOURCES,
    CLEAR_ANNOUNCER_LABEL,
    SET_ANNOUNCER_LABEL,
    CLOSE_MODAL,
    UPDATE_NETWORK_STATUS,
    CLOSE_NETWORK_TOAST,
    TOGGLE_SIDEMENU,
    SET_APP_CONFIG
} from '../actions/app';
import { createSelector } from 'reselect';

const app = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_LOCATION:
            return {
                ...state,
                page: action.page,
                pageId: action.pageId,
                endpoint: action.endpoint,
                categoryName: action.categoryName,
                itemName: action.itemName
            };
        case SET_APP_CONFIG:
            return {
                ...state,
                config: action.config
            };
        case RECEIVE_LAZY_RESOURCES:
            return {
                ...state,
                lazyResourcesLoaded: true
            };
        case CLEAR_ANNOUNCER_LABEL:
            return {
                ...state,
                announcerLabel: ''
            };
        case SET_ANNOUNCER_LABEL:
            return {
                ...state,
                announcerLabel: action.label
            };
        case CLOSE_MODAL:
            return {
                ...state,
                cartModalOpened: false
            };
        case UPDATE_NETWORK_STATUS:
            return {
                ...state,
                offline: action.offline,
                swToastOpen: action.offline || (state.offline !== undefined)
            };
        case CLOSE_NETWORK_TOAST:
            return {
                ...state,
                swToastOpen: false
            };
        case TOGGLE_SIDEMENU:
            return {
            ...state,
            swSidemenuOpen: !state.swSidemenuOpen
        };
        default:
            return state;
    }
}

export default app;

const pageSelector = state => state.app.page;

export const metaSelector = createSelector(
    pageSelector,
    (page) => {
        switch (page) {
            case 'home':
                return { title: 'Home' };
            default:
                return { title: 'Login' };
        }
    }
);
